"use client"

import type { QuestionAndAnswerItem } from "../types"
import "./styles.css"
import { useState } from "react"

type QuestionAndAnswerContentProps = {
  id: string
  title?: string
  faqs?: QuestionAndAnswerItem[]
  className?: string
}

type QuestionItemProps = {
  item: QuestionAndAnswerItem
  index: number
  idPrefix: string
}

const DOWN_ICON = "/images/become-member/down-thin.png"

const QuestionItem = ({ item, index, idPrefix }: QuestionItemProps) => {
  const [opened, setOpened] = useState(false)
  const answerId = `${idPrefix}-answer-${index}`

  return (
    <div className="tdf-qa-item">
      <button
        type="button"
        className={`tdf-qa-trigger ${opened ? "tdf-qa-trigger-open" : ""}`}
        onClick={() => setOpened(current => !current)}
        aria-expanded={opened}
        aria-controls={answerId}
      >
        <span className="tdf-qa-question">{item.question}</span>
        <img className="tdf-qa-icon" src={DOWN_ICON} alt="down-thin" width={13} height={8} />
      </button>

      <div id={answerId} className={`tdf-qa-collapse ${opened ? "tdf-qa-collapse-open" : ""}`}>
        <div className="tdf-qa-collapse-inner">
          <div className="tdf-qa-answer" dangerouslySetInnerHTML={{ __html: item.answer || "" }} />
        </div>
      </div>
    </div>
  )
}

export const QuestionAndAnswerContent = ({ id, title, faqs = [], className }: QuestionAndAnswerContentProps) => {
  const middleIndex = Math.ceil(faqs.length / 2)
  const leftColumn = faqs.slice(0, middleIndex)
  const rightColumn = faqs.slice(middleIndex)

  return (
    <section className={`tdf-qa-root ${className || ""}`} id={id}>
      {title && <h2 className="tdf-qa-title">{title}</h2>}

      <div className="tdf-qa-grid">
        <div className="tdf-qa-column">
          {leftColumn.map((item, index) => (
            <QuestionItem key={`left-${index}`} item={item} index={index} idPrefix={id} />
          ))}
        </div>

        <div className="tdf-qa-column">
          {rightColumn.map((item, index) => (
            <QuestionItem key={`right-${index}`} item={item} index={middleIndex + index} idPrefix={id} />
          ))}
        </div>
      </div>
    </section>
  )
}
